import { Navigate, Outlet } from "react-router-dom";

import useIsAuthorized from "Hooks/useIsAuthorized";
import useUserContext from "Hooks/useUserContext";

/** @component Wraps Login route in App to autologin if there is a valid JWT */
export default function Autologin() {
    const [userContext] = useUserContext();

    useIsAuthorized();

    // Do nothing until figuring out whether user is authenticated
    if (userContext.isAuthenticated === undefined) {
        return null;

        // If authenticated direct to appropriate page
    } else if (userContext.isAuthenticated) {
        // If Calance admin, direct to last page from localStorage if possible,
        // otherwise userContext.landingPage ("/run")
        if (userContext.isCalanceAdmin) {
            let lastPage = localStorage.getItem("lastPage");

            return <Navigate to={lastPage ?? userContext.landingPage} />;
        }

        return <Navigate to={userContext.landingPage} />;

        // Not authenticated, direct to login page
    } else {
        return <Outlet />;
    }
}
